// src/stone/icons/Pill.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var Pill = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "m15.493 16.907-8.4-8.4 1.414-1.414 8.4 8.4z" }),
      /* @__PURE__ */ jsx("path", { d: "M19.1 4.915c-2.022-1.93-5.194-1.907-7.093-.008L4.915 12c-1.928 2.02-1.907 5.187-.015 7.086 2.022 1.93 5.194 1.907 7.093.008L19.085 12c1.928-2.02 1.907-5.186.015-7.086m-8.507-1.422c2.698-2.699 7.12-2.678 9.899-.015l.008.007.007.008c2.699 2.698 2.677 7.12.015 9.899l-.007.008-7.108 7.107c-2.698 2.699-7.12 2.677-9.899.015l-.008-.007-.007-.008c-2.699-2.699-2.678-7.12-.015-9.899l.007-.008z" })
    ]
  }
);
var Pill_default = Pill;

export {
  Pill_default
};
